export default __webpack_public_path__ + "static/media/cloud-checked.257e5ac1.svg";